import styled, { css } from 'styled-components';
import { theme } from '~/styles/themes';

interface ParagraphProps {
  bold?: boolean;
  italic?: boolean;
}

export const Paragraph = styled.p<ParagraphProps>`
  line-height: 1.7em;
  margin-bottom: 1em;
  white-space: pre-wrap;
  ${(props) =>
    props.bold &&
    css`
      font-weight: 600;
    `}
  ${(props) =>
    props.italic &&
    css`
      font-style: italic;
    `}
`;

export const ContentContainer = styled.div`
  margin-top: 0.5em;
  padding: 0 1.5em;
  color: ${theme.colors.dark};
`;

export const ListItem = styled.li`
  padding: 0.3em 0;
  line-height: 1.7em;
`;

export const ListItemBold = styled.li`
  padding: 0.3em 0;
  line-height: 1.7em;
  font-weight: 600;
`;

export const OrderedListContainer = styled.ol`
  margin-bottom: 1em;
  list-style: decimal;
  padding-left: 1.5em;
`;

export const TextHeader = styled.h4`
  line-height: 1.7em;
  font-weight: 600;
  font-size: 1.29em;
  text-align: center;
  color: ${theme.colors.dark};
`;

export const UnorderedListContainer = styled.ul`
  padding: 0 2em;
  margin-bottom: 1em;
  list-style: disc;
`;
